import { toastError } from 'admination-react'
import { useCallback, useEffect } from 'react'
import type { ZertifikatView } from '@/core/data/portalViews'
import { PdfRegion, ZOOMED_OUT_PDF_SCALE } from '@/core/components/modal/PdfRegion'
import { useListActionsSink } from '@/core/components/list/listActions'
import { downloadFile } from '@/core/data/storage'
import { downloadBlob } from '@/core/lib/files'

export function ZertifikatTab({ zertifikat }: { zertifikat: ZertifikatView }) {
  const pdfPath = zertifikat.pdfPath ?? null

  const handleDownload = useCallback(async () => {
    if (!pdfPath) {
      toastError("Zertifikat konnte nicht geladen werden.")
      return
    }
    const blob = await downloadFile(pdfPath)
    if (!blob) {
      toastError("Zertifikat konnte nicht geladen werden.")
      return
    }
    downloadBlob(blob, "Zertifikat.pdf")
  }, [pdfPath])

  const sink = useListActionsSink()
  useEffect(() => {
    if (!sink) return
    sink({
      actions: [{ id: 'download', label: "Herunterladen", icon: 'i-download', primary: true, iconOnly: true }],
      onRun: (id) => {
        if (id === 'download') void handleDownload()
      },
    })
    return () => sink(null)
  }, [sink, handleDownload])

  return <PdfRegion
      path={pdfPath}
      loadingLabel="Zertifikat wird geladen …"
      placeholder="Zertifikat wird geladen…"
      scaleFactor={ZOOMED_OUT_PDF_SCALE}
    />
}
